import type { InvalidateCanvasListsParams } from '../types';

// A created/renamed/deleted canvas can surface under several filter pills
// (e.g. both `mine` and `all`), so lifecycle mutations invalidate every
// canvas-list query for the organization regardless of its filter suffix.
const invalidateCanvasLists = ({
    queryClient,
    organizationId,
}: InvalidateCanvasListsParams): Promise<void> =>
    queryClient.invalidateQueries({
        predicate: query =>
            typeof query.queryKey === 'string' &&
            query.queryKey.startsWith(`canvas-list-${organizationId}`),
    });

export default invalidateCanvasLists;
